import Menu from './Compartido/Menu.jsx';
import TextosGraciasTpv from './GraciasTpv/TextosGraciasTpv.jsx';
import Footer from './Compartido/Footer.jsx';

const GraciasPaycomet = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosGraciasTpv />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    )
}

export default GraciasPaycomet;
